import { Component, Input } from '@angular/core';
import { ApplicationAppEntityApplicationRead, ParcelAppEntityApplicationRead } from '../../../../../../../../openapi';
import { LabelComponent } from '../../../../../../../../common/label/label.component';
import { CommonModule } from '@angular/common';
import { ParcelsPreviewComponent } from '../../../../../common/components/parcels/parcels-preview/parcels-preview.component';
import {
  LocationReconstructionOfExitParcelsSectionTitlePipe
} from '../../pipes/location-reconstruction-of-exit-parcels-section-title.pipe';
import {
  LocationReconstructionOfExitParcels2SectionTitlePipe
} from '../../pipes/location-reconstruction-of-exit-parcels2-section-title.pipe';

@Component({
  selector: 'app-location-data-preview',
  standalone: true,
  imports: [
    LabelComponent,
    CommonModule,
    ParcelsPreviewComponent,
    LocationReconstructionOfExitParcelsSectionTitlePipe,
    LocationReconstructionOfExitParcels2SectionTitlePipe
  ],
  templateUrl: './location-data-preview.component.html'
})
export class LocationDataPreviewComponent {
  @Input()
  public application: ApplicationAppEntityApplicationRead | null = null;

  public get parcels(): ParcelAppEntityApplicationRead[] {
    return this.application?.parcels?.filter(v => v?.tag === 'parcels') || [];
  }

  public get parcels2(): ParcelAppEntityApplicationRead[] {
    return this.application?.parcels?.filter(v => v?.tag === 'parcels2') || [];
  }
}
